import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@/store/AppContext';
import App from './App';
import './index.css';
export { pwaChannel } from '@/utils/pwaChannel';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppProvider>
      <App />
    </AppProvider>
  </BrowserRouter>
);

// ---------------------------------------------------------------------------
// Service Worker registration + auto-update
// ---------------------------------------------------------------------------
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    const isDev = process.env.NODE_ENV === 'development';

    // In development always unregister old SWs/caches to prevent stale bundles.
    if (isDev) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((r) => r.unregister()));
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[PWA] Failed to clear SW/caches in development:', err);
      }
      return;
    }

    let refreshing = false;

    // When a new SW takes control, reload the page once to get the latest bundle.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      // eslint-disable-next-line no-console
      console.log('[PWA] New service worker activated — reloading for latest version.');
      window.location.reload();
    });

    // Also listen for the explicit SW_UPDATED message (belt-and-suspenders).
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_UPDATED') {
        // eslint-disable-next-line no-console
        console.log('[PWA] SW_UPDATED message received, version:', event.data.version);
        // The controllerchange listener above will handle the reload.
      }
    });

    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      // eslint-disable-next-line no-console
      console.log('[PWA] Service worker registered:', registration.scope);

      // Check for updates every 30 minutes so long-lived PWA sessions pick up deploys.
      setInterval(() => {
        registration.update().catch(() => {/* ignore offline errors */});
      }, 30 * 60 * 1000);

      // Also check immediately after the page becomes visible again (e.g. user returns to PWA).
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update().catch(() => {/* ignore */});
        }
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[PWA] Service worker registration failed:', err);
    }
  });
}

